exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flexRow[data-v-485542b4]{height:85vh;flex-direction:column;justify-content:center}.loadingMessage[data-v-485542b4],.title[data-v-485542b4]{margin:4rem auto 0}.title[data-v-485542b4]{font-size:3rem}button[data-v-485542b4]{font-size:1.5rem;padding:1rem 2rem;margin:0;background-color:#3498db;color:#fff;border:none}.logo[data-v-485542b4]{margin:1rem}.logo img[data-v-485542b4]{width:196px;height:196px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-485542b4&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/LoginView.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-485542b4&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/LoginView.vue
// module chunks = 0